import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    authData: null,
    userData: null,
    permissions: [],
    modules: [],
    storeId: null,
    brandName: localStorage.getItem("brandName") || "",
    isAdmin: false,
    raiseIssue: false,
    attribute: {},
  },
  reducers: {
    saveAuthData: (state, action) => {
      state.authData = action.payload;
    },
    saveUserData: (state, action) => {
      if (action.payload) {
        const { isAdmin, permissions, ...restOfUserData } = action.payload;

        state.userData = restOfUserData;
        state.isAdmin = isAdmin || false;
        state.permissions = permissions || [];
      } else {
        state.userData = null;
        state.isAdmin = false;
        state.permissions = [];
      }
    },
    saveModule: (state, action) => {
      state.modules = action.payload;
    },
    resetData: (state, action) => {
      state.userData = null;
      state.authData = null;
      state.permissions = [];
      state.storeId = null;
      state.isAdmin = false;
      state.brandName = "";
      localStorage.removeItem("storeId");
      localStorage.removeItem("brandName");
    },
    setAccessToken: (state, action) => {
      state.authData = state.authData && {
        ...state.authData,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      };
    },
    saveStoreData: (state, action) => {
      state.storeId = action.payload.storeId;
      state.brandName = action.payload.brandName;

      localStorage.setItem("storeId", action.payload.storeId);
      localStorage.setItem("brandName", action.payload.brandName);
    },
    setRaiseIssue: (state, action) => {
      state.raiseIssue = action.payload;
    },
    setAttribute: (state, action) => {
      state.attribute = action.payload;
    },
  },
});

export const {
  saveAuthData,
  saveUserData,
  resetData,
  setAccessToken,
  saveModule,
  saveStoreData,
  setRaiseIssue,
  setAttribute,
} = loginSlice.actions;

export default loginSlice.reducer;
